import React from 'react';
import { useIsIOS } from '@/hooks/useIsIOS';

interface IPadLayoutProps {
  children: React.ReactNode;
  className?: string;
  maxWidth?: 'sm' | 'md' | 'lg' | 'xl' | '2xl' | 'full';
  padding?: 'none' | 'sm' | 'md' | 'lg' | 'xl';
}

const IPadLayout: React.FC<IPadLayoutProps> = ({ 
  children, 
  className = '', 
  maxWidth = 'xl',
  padding = 'md'
}) => {
  const { isIPad, screenSize, orientation } = useIsIOS();

  if (!isIPad) {
    return <>{children}</>;
  }

  // Classes de largura máxima baseadas no tamanho do iPad
  const maxWidthClasses = {
    sm: 'max-w-sm',
    md: 'max-w-md', 
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    '2xl': 'max-w-2xl',
    full: 'max-w-full'
  };

  // Classes de padding baseadas no tamanho do iPad
  const paddingClasses = {
    none: '',
    sm: 'p-4 md:p-6 lg:p-8',
    md: 'p-6 md:p-8 lg:p-10',
    lg: 'p-8 md:p-10 lg:p-12',
    xl: 'p-10 md:p-12 lg:p-16'
  };

  // Classes específicas por tamanho de tela
  const sizeClasses = {
    small: 'ipad-small-layout',
    medium: 'ipad-medium-layout',
    large: 'ipad-large-layout'
  };

  // Classes específicas por orientação
  const orientationClasses = {
    portrait: 'ipad-portrait-layout',
    landscape: 'ipad-landscape-layout'
  };

  const combinedClasses = [
    'ipad-layout',
    sizeClasses[screenSize],
    orientationClasses[orientation],
    maxWidthClasses[maxWidth],
    paddingClasses[padding],
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={combinedClasses} data-ipad-size={screenSize} data-ipad-orientation={orientation}>
      <div className="mx-auto w-full">
        {children}
      </div>
    </div>
  );
};

export default IPadLayout;
